// 常量
export const SOFTWARE_PROJECT_ID = 1;
export const SOFTWARE_PROJECT_NAME = "TeamERP";

/**
 * 王磊个人项目Id
 */
export const WANGLEI_PROJECT_ID = 1;

/**
 * 王磊userId
 */
export const WANGLEI_USER_ID = 4;

/**
 * 秦艺梦userId
 */
export const QINYIMENG_USER_ID = 194;

/**
 * 陆滢userId
 */
export const LUYING_USER_ID = 204;

/**
 * 王欣userId
 */
export const WANGXIN_USER_ID = 11;